import {qs} from '../qs'

const BASE_PATH = '/data'

export default {
  getLidarData: query => ({
    url: `${BASE_PATH}/lidar`,
    method: 'POST',
    data: query
  }),
  getWindProfileData: query => ({
    url: `${BASE_PATH}/wind/radar`,
    method: 'POST',
    data: query
  }),
  getWindProfileMapData: (type, query) => ({
    url: `${BASE_PATH}/history/radar${type}`,
    method: 'POST',
    data: query
  }),
  getJSONData: fileName => ({
    url: `/static/dataJSON/${fileName}`,
    method: 'GET'
  }),
  getHistoryData: query => ({
    url: `${BASE_PATH}/historical/site`,
    method: 'POST',
    data: {
      ...query,
      isGetInvalidData: true
    }
  }),
  getRawData: query => ({
    url: `${BASE_PATH}/original/hour`,
    method: 'POST',
    data: {
      ...query
    }
  }),
  exportRawData: query => ({
    url: `${BASE_PATH}/original/hour/excel`,
    method: 'POST',
    data: {
      ...query
    },
    responseType: 'blob'
  }),
  getRealTimeData: query => ({
    url: `${BASE_PATH}/original/minute`,
    method: 'POST',
    data: {
      ...query
    }
  }),
  exportRealTimeData: query => ({
    url: `${BASE_PATH}/original/minute/excel`,
    method: 'POST',
    data: {
      ...query
    },
    responseType: 'blob'
  }),
  getAvgData: query => ({
    url: `/statistic/analysis/granularity/data`,
    method: 'POST',
    data: query
  }),
  getParticleSizeSpectraData: query => ({
    url: `${BASE_PATH}/particle/size/spectra`,
    method: 'POST',
    data: query
  }),
  getVOCCategoryData: query => ({
    url: `${BASE_PATH}/voc/para`,
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisGranularityData: query => ({
    url: '/statistic/analysis/granularity/data',
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisGranularityVoc: query => ({
    url: '/statistic/analysis/granularity/voc',
    method: 'POST',
    data: query
  }),
  getAQIData: query => ({
    url: '/aqi/data',
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisGranularityVOCsData: query => ({
    url: '/statistic/analysis/granularity/data/voc',
    method: 'POST',
    data: query
  }),
  getAQIGradeNumber: query => ({
    url: '/aqi/grade/number',
    method: 'POST',
    data: query
  }),
  getVOCsCategoryByGrade: query => ({
    url: '/statistic/analysis/voc/para/for/grade',
    method: 'POST',
    data: query
  }),
  getVOCsAndOther: query => ({
    url: '/statistic/analysis/voc/and/other',
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisVOCsOFP: query => ({
    url: '/statistic/analysis/ofp',
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisSOA: query => ({
    url: '/statistic/analysis/soa',
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisLOH: query => ({
    url: '/statistic/analysis/loh',
    method: 'POST',
    data: query
  }),
  getStatisticAnalysisVOCsIOFP: (siteId, query) => ({
    url: `/statistic/analysis/iofp/${siteId}${qs(query, '?')}`,
    method: 'GET'
  }),
  getStatisticAnalysisISOA: (siteId, query) => ({
    url: `/statistic/analysis/isoa/${siteId}${qs(query, '?')}`,
    method: 'GET'
  }),
  getStatisticAnalysisILOH: (siteId, query) => ({
    url: `/statistic/analysis/iloh/${siteId}${qs(query, '?')}`,
    method: 'GET'
  }),
  getVOCsCategoriesStatistic: query => ({
    url: `/statistic/analysis/granularity/data/voc/classify`,
    method: 'POST',
    data: query
  }),
  getVOCsOFPTotal: query => ({
    url: '/statistic/analysis/ofp/total',
    method: 'POST',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Data.js